import React from 'react';
import { Link } from 'react-router-dom';
import ToolTipWrapper from '../../../hoc/Wrp/ToolTipWrapper';
import Icons from '../../../Components/Icons/Icons';
import {parameterizedURLAccessToken} from '../../../Utils/CommonFunctions';

const userProfile = props => {
  const userDetail = props.userDetail;

	return (
		<div className="col-md-4">
            <div className={props.profileLoader === true ? "card card-profile is-loading" : "card card-profile"}>
              <div className="card-header p-1">
                <div className="profile-picture">
                  <div className="avatar avatar-xl">
                  {
                    userDetail.profile_avatar ?
                    <img src={parameterizedURLAccessToken('files/download?fileId='+userDetail.profile_avatar)} alt="Profile" className="avatar-img rounded-50 img-shadow" style={{height:'80px',width:'80px'}}/>
                    : <img src="assets/img/profile2.jpg" alt="Profile" className="avatar-img rounded-50 img-shadow" />
                  }
                  </div>
                  <div className="col-9 user-profile">
                    <div className="name third_dark_color pb-2">{userDetail.first_name+" "+userDetail.last_name}</div>
                    {/*<div className="job third_light_color">{userDetail.role_name}</div>*/}
                   
                    {/*<div className="view-profile"> <a href="#" className="btn secondary_bg btn-block">View Full Profile</a>
                    </div>*/}
                  </div>
                </div>
                <div className="btn-right pt-3 pr-3">
                  <Link data-tip="Edit" className="" to={ "/edit-user/"+userDetail.id}>
                    <Icons iconType="Edit" />
                  </Link>
                </div>
              </div>
              <div className="card-body">
                
                <div className="row user-stats text-center mb-0">
                  <div className="col">
                    {/* <div className="number fourth_light_color"><i className="fas fa-envelope"></i></div>
                    <div className="title">{userDetail.email}</div> */}

                    <div className="number fourth_light_color" title="Profile"><i className="fas fa-user-circle fa-lg"></i></div>
                    <div className="title">{userDetail.profile_name}</div>
                    
                  </div>                     
                  <div className="col">
                    <div className="number fourth_light_color" title="Role"><i className="fas fa-id-card-alt fa-lg"></i></div>
                     {/*<div className="title">{userDetail.phone_number}</div>*/}
                     <div className="title">{userDetail.role_name}</div>
                  </div>
                </div>
                
              </div>
              <div className="card-footer">
                <div className="card-title">User Information</div>
                <ul className="specification-list mt-2">
                  <li>  <span className="name-specification">First Name</span>
                    <span className="text-truncate status-specification secondary_color">{userDetail.first_name}</span>
                  </li>
                  <li>  <span className="name-specification">Last Name</span>
                    <span className="text-truncate status-specification secondary_color">{userDetail.last_name}</span>
                  </li>
                  <li>  <span className="name-specification">Email</span>
                    <span className="text-truncate status-specification secondary_color">{userDetail.email}</span>
                  </li>

                  {/*
                  <li>  <span className="name-specification">Role</span>
                    <span className="text-truncate status-specification secondary_color">{userDetail.role_name}</span>
                  </li>
                  <li>  <span className="name-specification">Profile</span>
                    <span className="text-truncate status-specification secondary_color" title='userDetail.profile_name'>{userDetail.profile_name}</span>
                  </li>
                  */}

                  <li>  <span className="name-specification">Work Number</span>
                    <span className="text-truncate status-specification secondary_color">{userDetail.work_number}</span>
                  </li>
                  <li>  <span className="name-specification">Mobile Number</span>
                    <span className="text-truncate status-specification secondary_color">{userDetail.mobile_number}</span>
                  </li>
                </ul>
              </div>
            </div>
            <ToolTipWrapper />
      	</div>
	)
}

export default userProfile;